import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  DepartamentsBusinessColorActionTypes,
  DepartamentsBusinessColorActionsUnion
} from '@core/actions/departaments-business-color.actions';
import { DepartamentsBusinessColor } from '@app/models/departamentsBusinessColor';

export interface State extends EntityState<DepartamentsBusinessColor> {
  loading: boolean;
  loaded: boolean;
  spinnerMessage: any;
}

export const adapter: EntityAdapter<
  DepartamentsBusinessColor
> = createEntityAdapter<DepartamentsBusinessColor>({
  selectId: (departamentsBusinessColor: DepartamentsBusinessColor) =>
    departamentsBusinessColor.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  spinnerMessage: null
});

export function reducer(
  state: State = INITIAL_STATE,
  action: DepartamentsBusinessColorActionsUnion
) {
  switch (action.type) {
    case DepartamentsBusinessColorActionTypes.Load:
      return { ...state, loading: true };

    case DepartamentsBusinessColorActionTypes.LoadFail:
      return { ...state, loading: false };

    case DepartamentsBusinessColorActionTypes.LoadSuccess:
      return adapter.addAll(action.departamentsBusinessColor, {
        ...state,
        loading: false,
        loaded: true
      });

    case DepartamentsBusinessColorActionTypes.AddOne:
      return adapter.addOne(action.departamentsBusinessColor, state);

    case DepartamentsBusinessColorActionTypes.AddAll:
      return adapter.addAll(action.departamentsBusinessColor, state);

    case DepartamentsBusinessColorActionTypes.Create:
      return { ...state, loading: true };

    case DepartamentsBusinessColorActionTypes.CreateFail:
    case DepartamentsBusinessColorActionTypes.CreateSuccess:
      return { ...state, loading: false };

    case DepartamentsBusinessColorActionTypes.UpdateOne:
      return adapter.updateOne(
        {
          id: action.departamentsBusinessColor.id,
          changes: action.departamentsBusinessColor
        },
        state
      );

    case DepartamentsBusinessColorActionTypes.Update:
      return {
        ...state,
        loading: true,
        spinnerMessage: 'Actualizando'
      };

    case DepartamentsBusinessColorActionTypes.UpdateSuccess:
      return {
        ...state,
        loading: false,
        spinnerMessage: 'Actualizacion Correcta'
      };
    case DepartamentsBusinessColorActionTypes.UpdateFail:
      return {
        ...state,
        loading: false,
        spinnerMessage: 'Actualizacion Fallida'
      };

    case DepartamentsBusinessColorActionTypes.Delete:
      return {
        ...state,
        loading: true,
        spinnerMessage: 'Eliminando color'
      };

    case DepartamentsBusinessColorActionTypes.DeleteSuccess:
      return {
        ...state,
        loading: false,
        spinnerMessage: 'Color Eliminado Correctamente'
      };

    // case DepartamentsBusinessColorActionTypes.DeleteFail:
    // return {
    //     ...state,
    //     loading: false,
    //     spinnerMessage: ''
    // };

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const selectSpinnerMessage = (state: State) => state.spinnerMessage;

export const getState = createFeatureSelector<State>(
  'departamentsBusinessColor'
);
export const getDepartamentsBusinessColor = createSelector(
  getState,
  selectAll
);
